import { IconButton, IconButtonProps } from "@mui/material"
import React, { ReactNode } from "react"

interface ViewButtonProps extends IconButtonProps {
  active?: boolean
  children: ReactNode
}

const getViewButtonStyles = (active?: boolean) => {
  const commonHoverStyles = {
    backgroundColor: "#D5F5FF",
    color: "#01294E",
    boxShadow: "0px 0px 10px #00000026",
    border: "1px solid #D5F5FF"
  }

  const commonStyles = {
    borderRadius: "5px",
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    boxShadow: "none",
    border: "1px solid #E0E0E0",
    color: "#898989",
    "&:hover": commonHoverStyles
  }

  if (active === true) {
    return {
      ...commonStyles,
      backgroundColor: "#D5F5FF",
      boxShadow: "0px 0px 6px #00000033",
      borderColor: "#D5F5FF",
      color: "#01294E"
    }
  } else if (active === false) {
    return {
      ...commonStyles,
      background: "#FFFFFF",
      borderColor: "#E0E0E0",
      color: "#E7E7E7"
    }
  } else {
    // active === undefined
    return {
      ...commonStyles
    }
  }
}

const ViewButton = ({ active, children, ...props }: ViewButtonProps) => {
  return (
    <IconButton
      {...props}
      sx={{
        ...getViewButtonStyles(active),
        ...props.sx
      }}
    >
      {children}
    </IconButton>
  )
}

export default ViewButton
